import axios from "axios";
import { showAlert, startLoading, stopLoading } from "@/state/app";

const apiClient = axios.create({
  baseURL:
    process.env.VUE_APP_API_URL ||
    "https://mh13.in/app/index.php/api/",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    if (config.globalLoading) {
      startLoading(config.loadingMessage || "Loading...");
    }

    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = token;

    return config;
  },
  (error) => {
    if (error.config?.globalLoading) stopLoading();
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    if (response.config?.globalLoading) stopLoading();
    return response;
  },
  (error) => {
    if (error.config?.globalLoading) stopLoading();

    if (error.response?.status === 401) {
      localStorage.removeItem("token");
    }

    const message =
      error.response?.data?.message ||
      (error.code === "ECONNABORTED"
        ? "Request timed out. Please try again."
        : "Something went wrong. Please try again.");

    showAlert(message, "error");
    return Promise.reject(error);
  }
);

export default apiClient;
